import React, { useState } from 'react';
import { Icon } from '@openedx/paragon';
import { RiArrowDownSLine } from '@remixicon/react';
import { FormattedMessage } from '@edx/frontend-platform/i18n';

import messages from './messages';

const Chevron = ({ open }) => (
  <Icon
    src={RiArrowDownSLine}
    size="xs"
    className={`course-outline__chevron${open ? ' course-outline__chevron--open' : ''}`}
  />
);

const Subsection = ({ subsection }) => {
  const [open, setOpen] = useState(false);
  const units = subsection.units || [];

  return (
    <li className="course-outline__subsection">
      <button
        type="button"
        className="course-outline__subsection-header"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <Chevron open={open} />
        <span>{subsection.name}</span>
      </button>
      {open && units.length > 0 && (
        <ul className="course-outline__units">
          {units.map((unit) => (
            <li key={unit.usage_key} className="course-outline__unit">
              {unit.name}
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

const Section = ({ section, defaultOpen }) => {
  const [open, setOpen] = useState(Boolean(defaultOpen));
  const subsections = section.subsections || [];

  return (
    <li className={`course-outline__section${open ? '' : ' course-outline__section--collapsed'}`}>
      <button
        type="button"
        className="course-outline__section-header"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <Chevron open={open} />
        <span>{section.name}</span>
      </button>
      {open && subsections.length > 0 && (
        <ul className="course-outline__subsections">
          {subsections.map((sub) => (
            <Subsection key={sub.usage_key} subsection={sub} />
          ))}
        </ul>
      )}
    </li>
  );
};

const CourseOutline = ({ sections }) => {
  if (!sections || sections.length === 0) return null;

  const visibleSections = sections.filter(
    (s) => !s.hide_from_toc && !s.visible_to_staff_only,
  );

  return (
    <section className="course-detail__outline">
      <h2 className="course-detail__section-title">
        <FormattedMessage {...messages.outlineHeading} />
      </h2>
      <ul className="course-outline__sections">
        {visibleSections.map((section, i) => (
          <Section
            key={section.usage_key}
            section={section}
            defaultOpen={i === 0}
          />
        ))}
      </ul>
    </section>
  );
};

export default CourseOutline;
